import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';

import { inject, observer } from 'mobx-react';

import { isEmpty } from 'lodash';

import { Modal, register } from 'sat-core';

import '../css/ProgressView.less';

import LeaderboardService from '../services/LeaderboardService';

const t = register('LeaderBoardModal');

export default
@inject('progressManager')
@observer
class LeaderBoardModal extends Component {
  renderTableHeader = (translationKey1, translationKey2) => {
    return (
      <div className='table-header'>
        <div className='table-title'>{t(translationKey1)}</div>
        <div className='table-title right'>{t(translationKey2)}</div>
      </div>
    );
  }

  renderAllRankedLeaderboardFaculties = () => {
    const { progressManager } = this.props;

    let leaderboard = progressManager.leaderboardJson.classLeaderboard || progressManager.leaderboardJson.leaderboard;
    if (!Array.isArray(leaderboard) || !leaderboard?.length) {
      leaderboard = [];
    }

    const allRankedLeaderboardFaculties = leaderboard.filter((facultyRankData) => !!facultyRankData);

    return LeaderboardService.renderRankedLeaderboardFaculties(allRankedLeaderboardFaculties, {
      className: 'leaderboard-rank-list all-leaderboard-rank-list'
    });
  }

  render() {
    const { closeModal, openModal, progressManager } = this.props;
    const { hasClassroomLeaderboardData, leaderboardJson } = progressManager;

    const isEmptyLeaderboard = isEmpty(leaderboardJson);

    return (
      <Modal
        className='progress-view'
        open={openModal}
        size='tiny'>
        <Modal.Header>{t('leaderboardHeader')}</Modal.Header>
        <Modal.Content scrolling>
          <div className='table-wrapper'>
            <div className='modal-leaderboard-body-description'>
              {t('leaderboardBodyDescription')}
            </div>
            {this.renderTableHeader(
              hasClassroomLeaderboardData || isEmptyLeaderboard ? 'allRankedLeaderboardClassrooms' : 'allRankedLeaderboardSchools',
              'leaderboardFacultyScore'
            )}
            {this.renderAllRankedLeaderboardFaculties()}
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button basic content='Close' onClick={() => { closeModal(); }} primary />
        </Modal.Actions>
      </Modal>
    );
  }
}
